module.exports = __webpack_public_path__ + "static/media/image_10.ca25407d.png";